import React from "react";
import Navbar from "../components/modules/Navbar";
import './EngagementsStyles.css'
import { BsFileArrowDown } from 'react-icons/bs'
import { Link as LinkScroll } from 'react-scroll';
import { BsArrowDownCircle } from 'react-icons/bs'
import Footer from "../components/modules/Footer";
import { AiOutlineRise } from 'react-icons/ai'
import { FaHandsHelping } from 'react-icons/fa'
import { BsFillPeopleFill } from 'react-icons/bs'
import { FaRecycle } from 'react-icons/fa'
import { BsLightbulb } from 'react-icons/bs'
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPluging from 'gsap/ScrollToPlugin'
import gsap from 'gsap';
import { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import Qualité from "../assets/pdf/Politique_qualité_TOSS_2024.pdf";

gsap.registerPlugin(ScrollTrigger, ScrollToPluging);


const Engagements = () => {
    const { t } = useTranslation('common');

    const onLoad = () => {
        gsap.timeline().fromTo("#engagements",
            {
                y: 50,
                opacity: 0,
            },
            {
                y: 0,
                opacity: 1,
                duration: 1.5,
            })

    }
    const FadeBottom = (elem, time) => {

        gsap.fromTo(
            elem,

            {
                y: 100,
                opacity: 0,


            },
            {
                opacity: 1,
                y: 0,

                duration: 0.8,
                delay: time,
                scrollTrigger: {
                    trigger: elem,
                    start: "-60% 80%",

                    end: "bottom center",
                    toggleActions: "play none none none",

                },

            }

        )

    }

    useEffect(() => {
        onLoad();
        FadeBottom('#link1', 0)
        FadeBottom('#link2', 0.2)
        FadeBottom('#link3', 0.4)
        FadeBottom('#link4', 0.6)
        FadeBottom('#link5', 0.8)
        FadeBottom('#text1', 0)
        FadeBottom('#text2', 0)
        FadeBottom('#text3', 0)
        FadeBottom('#text4', 0)
        FadeBottom('#text5', 0)

    }, [])
    return (
        <div>
            <Navbar scroll='true' color='#cd1238' />
            <div className="engagements">
                <div className="engagements-title" >
                    <h1 id='engagements'>{t('engagements.Titre')}</h1>
                    <h3 id='engagements'>
                        {t('engagements.Sous-tire')}
                    </h3>
                    <LinkScroll to='engagements-image' smooth={true} offset={100} duration={1000}> <BsFileArrowDown className='fleche-ambassade' /></LinkScroll>
                </div>
                <div className="engagements-image" id="engagements-image">

                    <div className="engagements-img">

                    </div>
                </div>
                <div className="engagements-link" >
                    <h2> {t('engagements.politique')}</h2>
                    <div className="engagements-link-content">
                        <div className="link-content" id='link1'>
                            <LinkScroll to='amelioration' smooth={true} offset={-20} duration={1500}>
                                <AiOutlineRise className="engagements-icons" />
                                <h3> {t('engagements.l_amelioration_continue')}</h3>
                                <BsArrowDownCircle className="fleche-down" />
                            </LinkScroll>

                        </div>
                        <div className="link-content" id='link2'>
                            <LinkScroll to='inclusion' smooth={true} offset={-20} duration={2000}>
                                <FaHandsHelping className="engagements-icons" />
                                <h3> {t('engagements.l_inclusion')}</h3>
                                <BsArrowDownCircle className="fleche-down" />
                            </LinkScroll>
                        </div>
                        <div className="link-content" id='link3'>
                            <LinkScroll to='diversite' smooth={true} offset={-20} duration={2000}>
                                <BsFillPeopleFill className="engagements-icons" />
                                <h3> {t("engagements.la_diversité")}</h3>
                                <BsArrowDownCircle className="fleche-down" />
                            </LinkScroll>
                        </div>
                        <div className="link-content" id='link4'>
                            <LinkScroll to='developpement' smooth={true} offset={-20} duration={2000}>
                                <FaRecycle className="engagements-icons" />
                                <h3> {t('engagements.Le_DD')}</h3>

                                <BsArrowDownCircle className="fleche-down" />
                            </LinkScroll>
                        </div>
                        <div className="link-content" id='link5'>
                            <LinkScroll to='innovation' smooth={true} offset={-20} duration={2000}>
                                <BsLightbulb className="engagements-icons" />
                                <h3>{t("engagements.L_innovation")}</h3>
                                <BsArrowDownCircle className="fleche-down" />
                            </LinkScroll>
                        </div>
                    </div>



                </div>
                <div className="engagements-card how" id='amelioration'>
                    <div className="circle-1-engagements"></div>
                    <div className="circle-4-engagements"></div>
                    <div className="circle-3-engagements"></div>

                    <h2> {t("engagements.l_amelioration_continue")}</h2>
                    <div className="engagements-presentation-content" id='text1'>
                        <p> {t("engagements.texte_amelioration")}</p>
                        <a href={Qualité} target="_blank" rel="noreferrer">
                            <button>Notre politique qualité</button>
                        </a>
                    </div>
                </div>
                <div className="engagements-card presentation" id='inclusion'>
                    <div className="circle-1-engagements"></div>
                    <div className="circle-2-engagements"></div>
                    <div className="circle-3-engagements"></div>
                    <h2> {t("engagements.l_inclusion")}</h2>
                    <div className="engagements-presentation-content" id='text2'>
                        <p>
                            {t("engagements.texte_inclusion")}


                        </p>


                    </div>
                </div>
                <div className="engagements-card how" id='diversite'>
                    <div className="circle-1-engagements"></div>
                    <div className="circle-4-engagements"></div>
                    <div className="circle-3-engagements"></div>

                    <h2> {t("engagements.la_diversité")}</h2>
                    <div className="engagements-presentation-content" id='text3'>
                        <p>{t("engagements.texte_diversité")}</p>
                    </div>
                </div>
                <div className="engagements-card presentation" id='developpement'>
                    <div className="circle-1-engagements"></div>
                    <div className="circle-2-engagements"></div>
                    <div className="circle-3-engagements"></div>
                    <h2> {t("engagements.Le_DD")}</h2>
                    <div className="engagements-presentation-content" id='text4'>
                        <p>
                            {t("engagements.dd1")}          </p>
                        <ul>
                            <li> {t("engagements.dd2")} </li>

                            <li>
                                {t("engagements.dd3")}
                            </li>
                            <li>
                                {t("engagements.dd4")}
                            </li>
                            <li>
                                {t("engagements.dd5")}
                            </li>
                            <li>
                                {t("engagements.dd6")}
                            </li>
                            <li>
                                {t("engagements.dd7")}

                            </li>
                            <li>
                                {t("engagements.dd8")}
                            </li>
                        </ul>
                        <p>
                            {t("engagements.dd9")}
                        </p>


                    </div>
                </div>
                <div className="engagements-card how" id='innovation'>
                    <div className="circle-1-engagements"></div>
                    <div className="circle-4-engagements"></div>
                    <div className="circle-3-engagements"></div>

                    <h2>     {t("engagements.L_innovation")} </h2>
                    <div className="engagements-presentation-content" id='text5'>
                        <p>     {t("engagements.texte_innov")} </p>
                    </div>
                </div>




            </div>
            <Footer color='#cd1238' color2='rgb(163 28 56)' />
        </div>
    )

}

export default Engagements